import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class GetNimbusPopupService {
  public openGetNimbusAuthPopup$: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }

  open() {
    this.openGetNimbusAuthPopup$.next();
  }
}
